export enum CleanupMode {
  Full = 'Full',
  None = 'None'
}
export interface TProcessMissingDataQueryParams {
  projectId: string;
  cleanupMode: CleanupMode;
}
